import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true, // send/receive the session_token httpOnly cookie
});

export { BACKEND_URL };
export default api;
